import {
  ChangeDetectorRef,
  Directive,
  ElementRef,
  HostListener,
  Input,
} from '@angular/core';
import { HookDirective } from '../core/hook';
import { useSubscription } from '../core/hooks';
import { MenuComponent } from './menu.component';

@Directive({
  selector: '[menuTrigger]',
})
export class MenuTriggerDirective extends HookDirective {
  @Input('menuTrigger')
  menu!: MenuComponent;

  @HostListener('click', ['$event'])
  click(evt: MouseEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.menu.toggleMenu();
  }

  @HostListener('keydown', ['$event.key'])
  keydown(key: string) {
    this.menu.keydown(key);
  }

  constructor(
    private readonly el: ElementRef,
    changeDetector: ChangeDetectorRef,
  ) {
    super(changeDetector);
  }

  get _() {
    useSubscription(
      this.menu.onClose,
      {
        next: focus => {
          if (focus) {
            this.el.nativeElement.focus();
          }
        },
      },
      [this.menu],
    );

    return;
  }
}
